import { http, HttpResponse } from "msw";

/**
 * TAK integration endpoints — what tak's UI calls directly when
 * rendered as a federation remote inside uiv2.
 *
 * /api/v2/descriptions/:language and /api/v2/instructions/data/tak are
 * already covered by handlers/products.ts; this file owns only the
 * TAK-specific paths.
 */
export const takHandlers = [
  // Listing of available data packages — UI shows the catalogue.
  http.get("/api/v1/tak-datapackages/*", () => {
    return HttpResponse.json({
      packages: [
        {
          name: "demo-baseline",
          description: "Baseline mission package for demo",
          size_bytes: 1024,
          updated_at: new Date(Date.now() - 86400000).toISOString(),
        },
      ],
    });
  }),

  // Mission package metadata — same shape as above; the UI only shows
  // counts and timestamps in the demo flow.
  http.get("/api/v1/tak-missionpackages/*", () => {
    return HttpResponse.json({
      packages: [
        {
          name: "demo-mission",
          description: "Demo mission package",
          size_bytes: 2048,
          updated_at: new Date(Date.now() - 3600000).toISOString(),
        },
      ],
    });
  }),
];
